import styled from "styled-components";
import { SimpleLoadingBall } from "./SimpleLoading";
import { useTranslation } from "@coworker/locales";

const CenteredContainer = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const SimpleDefaultLoadingScreen: React.FC = () => {
  const { t } = useTranslation();
  return (
    <CenteredContainer>
      <SimpleLoadingBall
        color={"emphasised"}
        size={"large"}
        text={t("loadingEllipsisString")}
      />
    </CenteredContainer>
  );
};

export { SimpleDefaultLoadingScreen };
